import { createSlice } from "@reduxjs/toolkit";

export const poadcastUrlSlice = createSlice({
  name: "poadcast",
  initialState: {
    url: null,
  },
  reducers: {
    changeUrl: (state, data) => {
      state.url = data.payload.url;
    },
  },
});

export const { changeUrl } = poadcastUrlSlice.actions;

export const poadcastUrl = (state) => state.rootReducer.poadcastUrlReducer.url;

export default poadcastUrlSlice.reducer;